import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";

const baseCardStyles = style({
  display: "inherit",
  flex: 1,
});

export const cardStyles = styleVariants({
  default: [baseCardStyles],
  responsive: [
    baseCardStyles,
    {
      "@media": {
        [`screen and (min-width:${breakpoints[1]})`]: {
          flex: "0 1 25%",
        },
      },
    },
  ],
});

export const chipTitle = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,
});

const baseButtonStyles = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: vars.space["2xs"],
  border: 0,
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.surfaceBright,
  cursor: "pointer",
  padding: vars.space["2xs"],
  width: "100%",
  whiteSpace: "nowrap",
  color: vars.colors.primary,
});

export const chipButtonStyles = styleVariants({
  default: [baseButtonStyles],
  unavailable: [
    baseButtonStyles,
    {
      opacity: 0.5,
      backgroundColor: "transparent",
    },
  ],
});

export const labelWrapper = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space["2xs"],
  width: "100%",
});

const baseLabelStyles = style({
  outline: `1px solid ${vars.colors.primary}`,
  borderRadius: vars.radii.xs,
  width: "100%",
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading["2xs"],

  selectors: {
    [`${baseButtonStyles}[data-hovered] &, ${baseButtonStyles}[data-focus-visible] &`]:
      {
        transitionDuration: "0.2s",
        transitionProperty: "all",
        backgroundColor: vars.colors.primary,
        color: vars.colors.onPrimary,
      },
  },
});

const activeStyles = style({
  outline: "none",
  background: `linear-gradient(to right, ${vars.colors.plBlue}, #6776ff)`,
});

export const chipActionLabel = styleVariants({
  available: [baseLabelStyles],
  cancelled: [baseLabelStyles],
  unavailable: [
    baseLabelStyles,
    {
      outline: "none",
    },
  ],
  active: [baseLabelStyles, activeStyles],
  proposed: [baseLabelStyles, activeStyles],
  played: {
    textWrap: "nowrap",
    fontSize: vars.fontSizes.heading["2xs"],
  },
  info: [
    baseLabelStyles,
    {
      outline: "none",
      backgroundColor: vars.colors.white,
    },
  ],
});

export const chipBadgeStyles = style({
  width: 24,
  height: 24,
});
